module.exports = __webpack_public_path__ + "static/sayflowers_b-53ae2742f61ea25b550b001aefe873bd.svg";